import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { DataTableComponent } from './components/data-table/data-table.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { ModalComponent } from './components/modal/modal.component';
import 'iconify-icon';
import { AlertComponent } from './components/alert/alert.component';
import { LoaderComponent } from './components/loader/loader.component';
import { AttachmentsModalComponent } from './components/attachments-modal/attachments-modal.component';
import { TemplateAttachmentsModalComponent } from './components/template-attachments-modal/template-attachments-modal.component';

@NgModule({
  declarations: [
    DataTableComponent,
    SearchBarComponent,
    TruncatePipe,
    ModalComponent,
    AlertComponent,
    LoaderComponent,
    AttachmentsModalComponent,
    TemplateAttachmentsModalComponent
  ],
  imports: [CommonModule, FormsModule, MatTooltip],
  exports: [
    DataTableComponent,
    SearchBarComponent,
    TruncatePipe,
    ModalComponent,
    AlertComponent,
    LoaderComponent,
    AttachmentsModalComponent,
    TemplateAttachmentsModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
